import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import Header from "components/Header/Header.jsx";
import Footer from "components/Footer/Footer.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Parallax from "components/Parallax/Parallax.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";

import homePageStyle from "assets/jss/material-kit-react/views/homePage.jsx";

// Sections for this page
import ProductSection from "./Sections/ProductSection.jsx";
import ThumbnailsSection from "./Sections/ThumbnailsSection.jsx";

const dashboardRoutes = [];

class HomePage extends React.Component {

  constructor(props) {
    super(props);
    const { params } = this.props.match;
    this.state = {query: params.query ? params.query : ""};

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    this.setState({query: event.target.value});
  }

  render() {
    const { classes, ...rest } = this.props;

    return (
      <div>
        <Header
          color="transparent"
          routes={dashboardRoutes}
          brand="Répliculte"
          fixed
          changeColorOnScroll={{
            height: 400,
            color: "white"
          }}
          {...rest}
        />
        <Parallax filter image={require("assets/img/movies.jpg")}>
          <div className={classes.container}>
            <GridContainer justify="center">
              <GridItem xs={12} sm={12} md={6}>
                <h1 className={classes.title}>Répliculte</h1>
                <h4>
                  Retrouvez toutes les plus grandes répliques de film
                </h4>
                <br />

                <div>
                  <CustomInput
                    white
                    inputRootCustomClasses={classes.inputRootCustomClasses}
                    formControlProps={{
                      fullWidth: true,
                      className: classes.formControl,
                    }}
                    inputProps={{
                      placeholder: "Rechercher une réplique culte",
                      inputProps: {
                        "aria-label": "Rechercher une réplique culte",
                        className: classes.searchInput,
                        onChange: this.handleChange
                      },
                      defaultValue: this.props.match.params.query
                    }}
                  />
                </div>

              </GridItem>
            </GridContainer>
          </div>
        </Parallax>
        <div className={classNames(classes.main, classes.mainRaised)}>
          <div className={classes.container}>
            <ThumbnailsSection query={this.state.query} />
            <ProductSection />
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default withStyles(homePageStyle)(HomePage);



// WEBPACK FOOTER //
// ./src/views/HomePage/HomePage.jsx